// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__BWrbK","content":"PageLayout_content__vb8lB","footer":"PageLayout_footer__lU1lO"};